export default __webpack_public_path__ + "static/media/kitematic.6e81c88c.svg";